import { useEffect, useRef } from 'react';

const ADSENSE_SCRIPT_ID = 'google-adsense-script';

/**
 * Loads Google AdSense Auto ads on blog pages only.
 * Set REACT_APP_ADSENSE_CLIENT_ID=ca-pub-XXXXXXXX in .env to enable.
 */
const AdSenseLoader = () => {
  const initializedRef = useRef(false);

  useEffect(() => {
    const clientId = process.env.REACT_APP_ADSENSE_CLIENT_ID;

    // Skip if AdSense is already loaded globally from public/index.html
    const existingGlobalScript = document.querySelector(
      'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
    );

    if (existingGlobalScript || !clientId || initializedRef.current) {
      if (existingGlobalScript) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          console.warn('AdSense push failed:', e);
        }
      }
      return undefined;
    }

    if (document.getElementById(ADSENSE_SCRIPT_ID)) {
      initializedRef.current = true;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.warn('AdSense push failed:', e);
      }
      return undefined;
    }

    const script = document.createElement('script');
    script.id = ADSENSE_SCRIPT_ID;
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
    script.crossOrigin = 'anonymous';
    script.setAttribute('data-ad-client', clientId);

    script.onload = () => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.warn('AdSense initialization failed:', e);
      }
    };

    document.head.appendChild(script);
    initializedRef.current = true;

    return undefined;
  }, []);

  return null;
};

export default AdSenseLoader;
